import {Page} from "../flair/Page.es6";
import {Transition} from "../class/Ui/Anim/Transition.es6";
import {Slug} from "../class/Slug.es6";

Page.go(function() {
	if(window.location.pathname.match(/^\/(apply|pay)\//)) {
		return;
	}

	document.querySelectorAll("[name=slug]").forEach(slugElement => {
		let slugMatchName = slugElement.dataset.slug;
		if(!slugMatchName) {
			return;
		}

		let slugMatchElement = slugElement.form.querySelector(`[name='${slugMatchName}']`);
		if(!slugMatchElement) {
			return;
		}

		slugMatchElement.addEventListener(
			"input",
			() => {
				slugElement.value = new Slug(slugMatchElement.value).toString();
			}
		);
	});

	// const turbo = new Turbo();
	// turbo.callback = clickLink;

	function clickLink(newDocument) {
		document.title = newDocument.title;
		let globalNav = document.querySelector("global-navigation");
		globalNav.innerHTML = newDocument.querySelector("global-navigation").innerHTML;
		globalNav.style.pointerEvents = "none";
		document.body.className = newDocument.body.className;

		if(document.body.classList.contains("uri--ac--index")) {
			globalNav.querySelector("a[href='/ac/']").href = "javascript:history.back()";
		}

		const transition = new Transition(document, newDocument, () => {
			globalNav.style.pointerEvents = "";
		});
		transition.start("main");

		setTimeout(() => {
			document.querySelectorAll("main.old-main").forEach(oldMain => {
				oldMain.remove();
			});
		}, 3000);
	}
});
